import React, { useState } from 'react';
import styles from './DemoRequestForm.module.css';
import { requestDemo } from '../services/api.ts';

interface DemoRequestFormProps {
  onClose: () => void;
}

const DemoRequestForm: React.FC<DemoRequestFormProps> = ({ onClose }) => {
  const [name, setName] = useState('');
  const [telephone, setTelephone] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [submitError, setSubmitError] = useState<string | null>(null);

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!name) newErrors.name = 'Name is required';
    if (!telephone) newErrors.telephone = 'Telephone number is required';
    if (!company) newErrors.company = 'Company/Institute name is required';
    if (!email) {
      newErrors.email = 'Email address is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      newErrors.email = 'Invalid email address';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitError(null); // Clear previous submission errors
    if (!validateForm()) {
      return;
    }

    try {
      await requestDemo({
        name,
        telephone,
        company,
        email,
      });
      setIsSubmitted(true);
    } catch (error: any) {
      setSubmitError(error.message || 'Failed to send demo request. Please try again.');
    }
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose}>&times;</button>
        {isSubmitted ? (
          <div className={styles.successMessage}>
            <h2>Thank you for your request!</h2>
            <p>We have received your request and will contact you soon.</p>
            <button onClick={onClose} className={styles.okButton}>OK</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <h2>Request a Demo</h2>
            {submitError && <p className={styles.errorText}>{submitError}</p>}
            <div className={styles.formGroup}>
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              {errors.name && <p className={styles.errorText}>{errors.name}</p>}
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="telephone">Telephone Number:</label>
              <input
                type="tel"
                id="telephone"
                value={telephone}
                onChange={(e) => setTelephone(e.target.value)}
                required
              />
              {errors.telephone && <p className={styles.errorText}>{errors.telephone}</p>}
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="company">Company/Institute Name:</label>
              <input
                type="text"
                id="company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                required
              />
              {errors.company && <p className={styles.errorText}>{errors.company}</p>}
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="email">Email Address:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {errors.email && <p className={styles.errorText}>{errors.email}</p>}
            </div>
            <button type="submit" className={styles.submitButton}>Submit Request</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default DemoRequestForm;
